import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {ClockInForm} from '../../../../Models/Rrhh/Clock-In/clock-in.model';
import {ClockInModelService} from '../../../Models/Rrhh/Clock-in/clock-in-model.service';
import {ClockInFilters} from '../../../../Models/Rrhh/Clock-In/clock-in-filters.model';
import {ClockInStoreForm} from '../../../../Models/Rrhh/Clock-In/clock-in-store.model';
import {SignClockInForm} from '../../../../Models/Rrhh/Clock-In/sign-clock-in-form.model';

@Injectable({
  providedIn: 'root'
})
export class ClockInApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: ClockInModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener el listado de fichajes agrupados por usuario
   *
   */
  public getUserClockInListGrouped(params: ClockInFilters | null, save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('timelogs/user', params).subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Obtener el listado de fichajes
   *
   */
  public getClockInList(params: ClockInFilters | null): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('timelogs/search', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Obtener el detalle de un fichaje
   *
   */
  public getClockInDetail(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getTimeLog', params, 'get').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Fichar
   *
   */
  public setClockIn(params: ClockInForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setFichaje', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Editar fichaje
   *
   */
  public editClockIn(params: ClockInStoreForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('editFichaje', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Firmar fichaje
   *
   */
  public signClockIn(params: SignClockInForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('sendTimeLogToSign', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }

}
